export default "__VITE_ASSET__Dw4Z1Jb4__"